/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ReactNode, useEffect } from "react";
import { useAuth0 } from "./Auth/Auth0";

type AuthWallProps = {
  children: ReactNode;
};

export function AuthWall({ children }: AuthWallProps) {
  const { user, loginWithRedirect } = useAuth0();

  useEffect(() => {
    const path = `${window.location.pathname}${window.location.search}`;
    if (!user) {
      loginWithRedirect({
        appState: {
          returnTo: path,
        },
      });
    }
  }, [loginWithRedirect, user]);

  if (user) {
    return <>{children}</>;
  }

  return <div />;
}
